import React from 'react'

const LoadingShimmer = ({ className = "w-full h-full" }) => {
  return (
    <div className={`bg-gray-900 ${className} relative overflow-hidden`}>
      {/* Base shimmer animation */}
      <div className="absolute inset-0 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 animate-pulse">
        {/* Subtle scanning line effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gray-700 to-transparent opacity-50 animate-pulse" 
             style={{ animationDuration: '2s', animationIterationCount: 'infinite' }}>
        </div>
      </div>
      
      {/* Camera icon overlay */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-gray-600 opacity-60">
          <svg className="w-16 h-16 animate-pulse" fill="currentColor" viewBox="0 0 24 24">
            <path d="M17 10.5V7a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h12a1 1 0 001-1v-3.5l4 4v-11l-4 4z"/>
          </svg>
        </div>
      </div>
      
      {/* Status indicator */}
      <div className="absolute bottom-4 left-4 flex items-center space-x-2">
        <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
        <span className="text-gray-400 text-sm">Connecting...</span>
      </div>
    </div>
  )
}

export default LoadingShimmer
